export const ID_INITIAL_VOYAGE = 217;
export const ID_TRANSHIPMENT_TYPE_VOYAGE = 218;
export const ID_FINAL_DESTINATION_VOYAGE = 219;
export const ID_COLLECT_VOYAGE = 214;
export const ID_DELIVERY_VOYAGE = 221;
export const ID_RECEIVING_LOCATION = 216; // LOCAL RECEBIMENTO
